import { Divider } from 'antd';
import { InputFromUser } from '../../components/Input/input';
import { Options } from '../../utils/Data';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const ExaminationSection = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  IsFilledForm,
}) => {
  return (
    <>
      {/* Upshay Anupshay Examination */}
      <div className="row mb-3">
        <div className="col-12 col-md-6 mb-3 mb-md-0">
          <InputFromUser
            disabled={IsFilledForm}
            placeholder={'Enter Your Upshay'}
            type="singleSelect"
            options={Options.Upshay}
            name="upshay"
            onChange={v =>
              handleChange({
                target: {
                  name: 'upshay',
                  value: v,
                },
              })
            }
            value={values.upshay}
            FormGroupClassName={'w-100'}
            LabelClassName={'col-form-label'}
            onBlur={handleBlur}
            label="Upshay"
            error={errors.upshay}
            touched={touched.upshay}
          />
        </div>
        <div className="col-12 col-md-6">
          <InputFromUser
            disabled={IsFilledForm}
            placeholder={'Enter Your Anupshay'}
            type="singleSelect"
            options={Options.Anupshay}
            name="anupshay"
            onChange={v =>
              handleChange({
                target: {
                  name: 'anupshay',
                  value: v,
                },
              })
            }
            value={values.anupshay}
            FormGroupClassName={'w-100'}
            LabelClassName={'col-form-label'}
            onBlur={handleBlur}
            label="Anupshay"
            error={errors.anupshay}
            touched={touched.anupshay}
          />
        </div>
      </div>

      <div className="row">
        <InputFromUser
          disabled={IsFilledForm}
          placeholder={'Enter Your Jiva'}
          type="multiple"
          name="jivha"
          LabelClassName={'col-form-label'}
          onBlur={undefined}
          label="Jiva"
          FormGroupClassName={'col-xl-3 col-md-12'}
          onChange={v =>
            handleChange({
              target: {
                name: 'jivha',
                value: v,
              },
            })
          }
          value={values.jivha}
          FormControlClassName={'form-control'}
          options={Options.Jivha}
          error={errors.jivha}
          touched={touched.jivha}
        />
        <InputFromUser
          disabled={IsFilledForm}
          placeholder={'Enter Your Nails'}
          type="singleSelect"
          name="nails"
          LabelClassName={'col-form-label'}
          onBlur={undefined}
          label="Nails"
          FormGroupClassName={'col-xl-3 col-md-12'}
          onChange={v =>
            handleChange({
              target: {
                name: 'nails',
                value: v,
              },
            })
          }
          value={values.nails}
          FormControlClassName={'form-control'}
          options={Options.Nails}
          error={errors.nails}
          touched={touched.nails}
        />
        <InputFromUser
          disabled={IsFilledForm}
          placeholder={'Enter Your Eyes'}
          type="singleSelect"
          name="eyes"
          LabelClassName={'col-form-label'}
          onBlur={undefined}
          label="Eyes"
          FormGroupClassName={'col-xl-3 col-md-12'}
          onChange={v =>
            handleChange({
              target: {
                name: 'eyes',
                value: v,
              },
            })
          }
          value={values.eyes}
          FormControlClassName={'form-control'}
          options={Options.Eyes}
          error={errors.eyes}
          touched={touched.eyes}
        />
        <InputFromUser
          disabled={IsFilledForm}
          placeholder={'Enter Your Prakruti'}
          type="multiple"
          name="prakruti"
          LabelClassName={'col-form-label'}
          onBlur={undefined}
          label="Prakruti"
          FormGroupClassName={'col-xl-3 col-md-12'}
          onChange={v =>
            handleChange({
              target: {
                name: 'prakruti',
                value: v,
              },
            })
          }
          value={values.prakruti}
          FormControlClassName={'form-control'}
          options={Options.Prakruti}
          error={errors.prakruti}
          touched={touched.prakruti}
        />
      </div>
      <Divider />
      <InputFromUser
        disabled={IsFilledForm}
        placeholder={'Enter Your Nadi'}
        type="multiple"
        name="nadi"
        LabelClassName={'col-form-label'}
        onBlur={undefined}
        label="Nadi"
        FormGroupClassName={'col-xl-3 col-md-12'}
        onChange={v =>
          handleChange({
            target: {
              name: 'nadi',
              value: v,
            },
          })
        }
        value={values.nadi}
        FormControlClassName={'form-control'}
        options={Options.Nadi}
        error={errors.nadi}
        touched={touched.nadi}
      />

      {/* Nada */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <div className="mb-3">
                <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FeatherIcon icon="music" size="20" style={{ color: '#4f46e5' }} />
                  Nada (Sound Examination)
                </h4>
              </div>
              <div className="row">
                {values?.naad &&
                  values?.naad?.map((item, i) => {
                    let NewValue = { ...values };
                    const NameV = Object.keys(item)?.[0];
                    return (
                      <InputFromUser
                        disabled={IsFilledForm}
                        key={i}
                        label={Object.keys(item)?.[0]}
                        type="singleSelect"
                        FormGroupClassName={'col-xl-6 col-md-12'}
                        LabelClassName={'col-form-label'}
                        name={'yakrut'}
                        onChange={value => {
                          NewValue.naad[i] = {
                            [NameV]: value,
                          };
                          handleChange({
                            target: {
                              name: 'naad',
                              value: NewValue.naad,
                            },
                          });
                        }}
                        FormControlClassName={'form-control'}
                        onBlur={value => { }}
                        error={
                          typeof errors.naad === 'string'
                            ? errors.naad
                            : errors.naad?.find(e => e?.[Object.keys(item)?.[0]])?.[
                            Object.keys(item)?.[0]
                            ] || ''
                        }
                        value={item?.[NameV]}
                        options={
                          NameV === 'Yakrut'
                            ? Options.Nada.Yakrut
                            : Options.Nada.Pleeha
                        }
                        touched={true}
                        placeholder={`Enter Your ${NameV === 'Yakrut' ? 'Yakrut' : 'Pliha'}`}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sparshasahatva */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <div className="mb-3">
                <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FeatherIcon icon="target" size="20" style={{ color: '#4f46e5' }} />
                  Sparshasahatva (Palpation)
                </h4>
              </div>
              <div className="row">
                {values?.sparshaSahatva?.map((item, i) => {
                  let NewValue = { ...values };
                  const NameV = Object.keys(item)?.[0];
                  return (
                    <InputFromUser
                      disabled={IsFilledForm}
                      type="multiple"
                      key={i}
                      label={Object.keys(item)?.[0]}
                      FormGroupClassName={'col-xl-6 col-md-12'}
                      LabelClassName={'col-form-label'}
                      name={'sparshaSahatva'}
                      onChange={value => {
                        NewValue.sparshaSahatva[i] = {
                          [NameV]: value,
                        };
                        handleChange({
                          target: {
                            name: 'sparshaSahatva',
                            value: NewValue.sparshaSahatva,
                          },
                        });
                      }}
                      FormControlClassName={'form-control'}
                      onBlur={value => { }}
                      error={
                        typeof errors.sparshaSahatva === 'string'
                          ? errors.sparshaSahatva
                          : errors.sparshaSahatva?.find(
                            e => e?.[Object.keys(item)?.[0]]
                          )?.[Object.keys(item)?.[0]] || ''
                      }
                      value={item?.[NameV]}
                      options={
                        NameV === 'Yakrut'
                          ? Options.SparshasahatvaSubOptions.Yakrut
                          : NameV === 'Pleeha'
                            ? Options.SparshasahatvaSubOptions.Pleeha
                            : NameV === 'Dakshi Vruka'
                              ? Options.SparshasahatvaSubOptions.DakshiVruka
                              : NameV === 'Vaam Vruka'
                                ? Options.SparshasahatvaSubOptions.VaamVruka
                                : NameV === 'Apan Kaksha'
                                  ? Options.SparshasahatvaSubOptions.ApanKaksha
                                  : []
                      }
                      touched={true}
                      placeholder={`Enter Your ${NameV}`}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExaminationSection;